// extracted by mini-css-extract-plugin
export default {"container":"styles_container__is1Ef","title":"styles_title__bH-fz","info":"styles_info__Fm4NX","animateText":"styles_animateText__Elo98"};